import { useState, useEffect } from 'react';
import { captureException } from '@pegasus/sentry';
import { fetchCustomerIncentives } from '../api';
/**
 * Hook to fetch birthday voucher data from Phoenix API
 * Self-contained data fetching - no Redux dependency
 */
export var useBirthdayVoucherData = function () {
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState(null), customerIncentive = _b[0], setCustomerIncentive = _b[1];
    useEffect(function () {
        setLoading(true);
        fetchCustomerIncentives()
            .then(function (data) {
            var _a, _b;
            // Find birthday-related coupon that's not already applied
            var birthdayIncentive = (_b = (_a = data.items) === null || _a === void 0 ? void 0 : _a.find(function (item) {
                return item.use_case &&
                    item.use_case.toUpperCase() === 'BIRTHDAY' &&
                    item.coupon &&
                    !item.coupon.is_applied;
            })) !== null && _b !== void 0 ? _b : null;
            setCustomerIncentive(birthdayIncentive);
        })
            .catch(function (error) {
            console.error('Failed to fetch customer incentives:', error);
            captureException(error);
            setCustomerIncentive(null);
        })
            .finally(function () { return setLoading(false); });
    }, []);
    return { customerIncentive: customerIncentive, loading: loading };
};
